<label class="telenet-checkbox">
   <input data-testid="telenet-checkbox-input" class="telenet-checkbox-input" type="checkbox" [ngModel]="ngModel" (ngModelChange)="onModelChange($event)" [disabled]="disabled" />
   <div class="telenet-checkbox-custom" [class.checked]="ngModel" [class.disabled]="disabled">
      @if (ngModel) {
         <telenet-icon name="tick"></telenet-icon>
      }
   </div>
   <label class="telenet-checkbox-label" [class.disabled]="disabled">
      <ng-content></ng-content>
   </label>
</label>
